<template>
    <drawer title="Taxonomy" class="flex-taxonomy-editor">
        <div class="flex-taxonomy-container">
            <taxonomy-data
                submit-button-text="SUBMIT"
                :data="pageDataNew"
                :edit-mode="true"
                @save="onSave"
                @cancel="hideDrawer"
            />
        </div>
    </drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { TaxonomyData as TaxonomyDataModel } from '@/data/data-models';
import Drawer from '@/components/shared/drawer/drawer';
import TaxonomyData from '@/components/page-editor/shared/taxonomy/taxonomy-data';
import { SET_PAGE_DATA, SET_CHANGED_DATA, HIDE_DRAWER } from '@/store/types/mutation-types';

export default {
    name: 'taxonomy-editor',
    components: { Drawer, TaxonomyData },

    data() {
        return {
            pageDataNew: { tags: [] },
        };
    },

    computed: {
        ...mapState({
            pageData: state => state.page.pageData,
        }),
    },

    watch: {
        pageData: {
            handler(val) {
                this.setData(val);
            },
            immediate: true,
        },
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
            setChangedData: SET_CHANGED_DATA,
            setPageData: SET_PAGE_DATA,
        }),

        openCM() {
            const itemid = this.pageData.pageData.id;
            const lang = this.pageData.pageData.language;
            const cmurl = `${ process.env.VUE_APP_CM_URL }/sitecore/shell/sitecore/content/Applications/Content Editor.aspx?id=${ itemid }&la=${ lang }&fo=${ itemid }`;
            window.open(cmurl);
        },

        onSave(updatedPageData) {
            const currentPageData = this.pageData;
            currentPageData.pageData = {
                ...currentPageData.pageData,
                tags: updatedPageData.tags,
            };

            this.setChangedData(true);
            this.hideDrawer();
        },

        setData(data) {
            if (data) {
                this.pageDataNew = new TaxonomyDataModel(data.pageData.tags);
            }
        },
    },
};
</script>

<style lang="scss">
.flex-taxonomy-editor {
    overflow-y: auto;

    &__button {
        padding: 7px 15px;
        margin-left: 35px;
        margin-top: 10px;
        border-radius: 4px;
        font-size: 13px;
        color: var(--form-buttonColor);
        background-color: var(--form-buttonBackgroundColor);
        min-width: 100px;
    }

    .flex-taxonomy-container {
        min-width: 100%;
        height: calc(100vh - 83px - 50px); // 83 is top bar, 50 is buttons on bottom
        overflow-y: auto;
        padding: 20px 0;
    }
}
</style>
